import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { COD_EARLY_PAYMENT_TOOLTIP } from '../../../utils/paymentTermUtils';
import './CodEarlyPaymentInfoIcon.css';

const CodEarlyPaymentTooltip = (overlayProps) => (
    <Tooltip {...overlayProps} className='cust-tooltip cod-early-payment-tooltip'>
        {COD_EARLY_PAYMENT_TOOLTIP}
    </Tooltip>
);

const CodEarlyPaymentInfoIcon = () => {
    return (
        <OverlayTrigger
            placement='auto'
            trigger={['hover', 'focus', 'click']}
            delay={{ show: 200, hide: 150 }}
            overlay={CodEarlyPaymentTooltip}>
            <i
                className='bi bi-info-circle font-b3 ms-1 align-middle'
                tabIndex={0}
                role='button'
                aria-label='COD early payment info'
                style={{ cursor: 'pointer' }}
            />
        </OverlayTrigger>
    );
};

export default CodEarlyPaymentInfoIcon;
